import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import Sidebar from '../../components/Sidebar'; // Corrected path
import { BiTime, BiPlus } from 'react-icons/bi'; // Import icons from react-icons/bi
import { FaTruck } from 'react-icons/fa'; // Import truck icon from react-icons/fa
import './RulesLayout.scss'; // Add appropriate styles if needed

const RulesLayout = ({ children }) => {
  return (
    <div className="rules-layout">
      <Sidebar>
        <nav>
          <ul>
            <li>
              <Link to="/rules/carriage">
                <FaTruck className="me-2" /> Carriage Rules
              </Link>
            </li>
            <li>
              <Link to="/rules/closing">
                <BiTime className="me-2" /> Closing Rules
              </Link>
            </li>
            <li>
              <Link to="/rules/carriage/add">
                <span className="icon-combo">
                  <BiPlus className="me-1" />
                  <FaTruck className="me-2" />
                </span>
                Create Carriage Rule
              </Link>
            </li>
            <li>
              <Link to="/rules/closing/add">
                <span className="icon-combo">
                  <BiPlus className="me-1" />
                  <BiTime className="me-2" />
                </span>
                Create Closing Rule
              </Link>
            </li>
          </ul>
        </nav>
      </Sidebar>
      <main className="rules-content">
        {children || <Outlet />}
      </main>
    </div>
  );
};

export default RulesLayout;
